var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateAcc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 912,
    height: 802.5,
    viewBox: "0 0 912 802.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1.01 460.52 401.51)",
    id: "BhcztgEaTqDlUUgLw1sHJ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(41,60,219)",
      strokeOpacity: 0.53,
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,242,209)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -449.07628 379.05451 C -457.54603 309.14078 -425.27912 240.51837 -365.8411 202.03724 L -155.00411 65.53801999999999 L -155.00411 65.53801999999999 C -128.47033 48.35962999999999 -110.17978 21.154239999999987 -104.38650999999999 -9.750680000000017 C -98.59323999999998 -40.65560000000002 -105.80217999999999 -72.56640000000002 -124.33666 -98.06122000000002 L -124.33666 -98.06122000000002 L -124.33666 -98.06122000000002 C -166.00659 -155.37963000000002 -171.809 -231.02531000000002 -139.36158 -293.94019000000003 C -106.91416000000001 -356.85507 -41.68408000000001 -396.43844 29.54697999999999 -396.43844 L 450.41268 -396.43844 L 450.41268 395.22821999999996 L -446.97029 396.43841999999995 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAcc);
export default __webpack_public_path__ + "static/media/createAcc.385e8ee2f4e896eeb951f9a229c0ef32.svg";
export { ForwardRef as ReactComponent };